'use strict';

angular.module('msSleep').service('sleepScheduleSvc', ['httpSvc', function (httpSvc) {
  var WARNING_THRESHOLD = 30;
  var ERROR_THRESHOLD = 60;
  var SLEEP_BUFFER = 30;

  function getSchedule(weeklyCheckin) {
    weeklyCheckin = weeklyCheckin || false;
    return httpSvc.get('/apiproxy/user/sleepdiary/schedule?forWeeklyCheckin=' + weeklyCheckin);
  }

  function saveSchedule(request) {
    return httpSvc.post('/apiproxy/user/sleepdiary/schedule', request);
  }

  function getDifferenceInMinutes(recommendedTime, proposedTime) {
    return Math.abs(moment(recommendedTime).diff(moment(proposedTime), 'minutes'));
  }

  function isValidInBedTimeChange(amount, current, minimum, maximum) {
    return current - amount <= maximum && current - amount >= minimum;
  }

  function isValidWakeUpTimeChange(amount, current, minimum, maximum) {
    return current + amount <= maximum && current + amount >= minimum;
  }

  return {
    getSchedule: getSchedule,
    saveSchedule: saveSchedule,
    getDifferenceInMinutes: getDifferenceInMinutes,
    isValidInBedTimeChange: isValidInBedTimeChange,
    isValidWakeUpTimeChange: isValidWakeUpTimeChange,
    WARNING_THRESHOLD: WARNING_THRESHOLD,
    ERROR_THRESHOLD: ERROR_THRESHOLD,
    SLEEP_BUFFER: SLEEP_BUFFER
  };
}]);